import { Layout } from "../../../ui/layout";
import { MenuItems } from "../../../ui/organisms/navbar/dto";
import { RightBar } from "../../../ui/organisms/rightBar";
import { SOTList } from "./list";
import { SOTRight } from "./right";

export function SOTAdmin() {
    return (
        <Layout menuItem={MenuItems.USERS} breadcrumbItems={['Dashboard', 'Strumenti', 'Gestione', 'Gestione SOT']}
            noPaddingLat
            headerLabel="Gestione SOT"
        >
            <div className="bg-brandPrimary-100" style={{ display: 'flex', height: '100%' }}>
                <SOTList />
                
                <div className="bg-brandPrimary-100" style={{ flex: 0.3, borderTopRightRadius: '20px' }}>
                    <RightBar>
                        <SOTRight />
                    </RightBar>
                </div>
            </div>
        </Layout>
    )
}